// State object
import { InfluxDB } from "@influxdata/influxdb-client";
import store from "@/store/index";
import OctoberData from "@/mixins/octoberData";
import SnapchatData from "@/assets/static/snapshot.json";
import axios from "axios";

const state = {
	config: {
		INFLUX_URL: "https://us-east-1-1.aws.cloud2.influxdata.com",
		INFLUX_TOKEN:
			"WTEP2YugFLVzeztghgeekD-jELiiQ0IDrbiO3bJs7FEv4ThEfXWINrx9bCVS-gtXG34YjmdOU9zq109bmKGDqw==",
		INFLUX_ORG: "bgpoc@stinchcombe.co.uk",
		INFLUX_BUCKET: "bgoffice",
		DAYTARIFF: 15.3022,
		NIGHTTARIFF: 11.2552,
		WHEATHER_KEY: "a95e9d844b3ed5563ab65eae56709bfc",
	},
	currentDayPower: [],
	genPower: [],
	currentNightPower: [],
	prevDayPower: [],
	prevNightPower: [],
	beforePrevDayPower: [],
	beforePrevNightPower: [],
	predictDayPower: [],
	predictNightPower: [],
	apiURL: "https://api.knowatt.com"
};

// Getter functions
const getters = {
	getCurrentDayPower(state) {
		return state.currentDayPower;
	},
	getGenPower(state) {
		return state.genPower;
	},
	getCurrentNightPower(state) {
		return state.currentNightPower;
	},
	getPrevDayPower(state) {
		return state.prevDayPower;
	},
	getPrevNightPower(state) {
		return state.prevNightPower;
	},
	getBeforePrevDayPower(state) {
		return state.beforePrevDayPower;
	},
	getBeforePrevNightPower(state) {
		return state.beforePrevNightPower;
	},
	getPredictDayPower(state) {
		return state.predictDayPower;
	},
	getPredictNightPower(state) {
		return state.predictNightPower;
	},
};

// Mutations
const mutations = {
	setCurrentDayPower(state, power) {
		state.currentDayPower = power;
	},
	setGenPower(state, power) {
		state.genPower = power;
	},
	setCurrentNightPower(state, power) {
		state.currentNightPower = power;
	},
	setPrevDayPower(state, power) {
		state.prevDayPower = power;
	},
	setPrevNightPower(state, power) {
		state.prevNightPower = power;
	},
	setBeforePrevDayPower(state, power) {
		state.beforePrevDayPower = power;
	},
	setBeforePrevNightPower(state, power) {
		state.beforePrevNightPower = power;
	},
	setPredictDayPower(state, power) {
		state.predictDayPower = power;
	},
	setPredictNightPower(state, power) {
		state.predictNightPower = power;
	},
};

// Actions
const actions = {
	getInfluxData({ commit, state }, query) {
		let queryAPI = new InfluxDB({
			url: state.config.INFLUX_URL,
			token: state.config.INFLUX_TOKEN,
		}).getQueryApi(state.config.INFLUX_ORG);

		return queryAPI.collectRows(
			`from(bucket:"${state.config.INFLUX_BUCKET}") ${query}`
		);
	},
	async getLineChartData({ commit, state, dispatch, rootState }, query) {
		try {
			const { data } = await axios.get(state.apiURL + "/power/getLineChartData.php", {
				params: {
					query: query.query,
					range: query.range,
					site: rootState.auth.defaultSiteName !== '' ? rootState.auth.defaultSiteName : rootState.auth.user.site
				},
			});
			return data;
		} catch (error) {
			console.log(error)
		}
	},
	async getPeriodConsumption({ commit, state, dispatch, rootState }, query) {
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
		if (query.devices.length > 0) {
			try {
				const { data } = await axios.get(state.apiURL + "/power/getPeriodConsumption.php", {
					params: {
						devices: query.devices,
						range: query.range,
						site: rootState.auth.defaultSiteName !== '' ? rootState.auth.defaultSiteName : rootState.auth.user.site
					},
				});
				return data[0];
			} catch (error) {
				console.log(error)
			}
		} else {
			return [];
		}
	},
	async getWeekData({ commit, state, dispatch, rootState }, devices) {
		let query = [];
		let thisWeekPower = [];
		let prevWeekPower = [];
		let predictPower = [];
		let today = [];
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');

		try {
			const fielddata = {
				period: store.state.settime.periodTime,
				site: rootState.auth.defaultSiteName !== '' ? rootState.auth.defaultSiteName : rootState.auth.user.site,
				devices: devices
			};

			const { data } = await axios.post(state.apiURL + "/power/getWeekData.php", fielddata);
			thisWeekPower = data.current;
			prevWeekPower = data.prev;
			today = data.today;

			let rate = 0;
			if (thisWeekPower.length > 0) {
				let count = 0;
				for (let i = 0; i < thisWeekPower.length; i++) {
					if (!!prevWeekPower[i]) {
						rate += ((thisWeekPower[i][1] - prevWeekPower[i][1]) / prevWeekPower[i][1]) * 100;
						count++;
					}
				}
				if (count > 0) rate = rate / count;
				if (rate > 1000) rate = 1;
				for (let i = thisWeekPower.length; i < prevWeekPower.length; i++) {
					if (!!prevWeekPower[i]) {
						let time = new Date(prevWeekPower[i][0]);
						time.setDate(time.getDate() + 7);
						let timeString = time.toISOString();
						let value = (prevWeekPower[i][1] * (100 + rate)) / 100;
						predictPower.push([
							timeString,
							Math.round((value + Number.EPSILON) * 100) / 100,
						]);
					}
				}
			}

			return [thisWeekPower, predictPower, today];
		} catch (error) {
			console.log(error)
		}

	},
	async getDailyMapData({ commit, state, dispatch, rootState }) {
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
		try {
			const { data } = await axios.get(state.apiURL + "/power/getMapData.php", {
				params: {
					period: store.state.settime.periodTime,
					site: rootState.auth.defaultSiteName !== '' ? rootState.auth.defaultSiteName : rootState.auth.user.site
				},
			});
			let site = rootState.auth.defaultSiteName !== '' ? rootState.auth.defaultSiteName : rootState.auth.user.site;
			return data;
		} catch (error) {
			console.log(error);
		}
	},
	async getApplience({ commit, state, dispatch, rootState }, field) {
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');

		try {
			const { data } = await axios.get(state.apiURL + "/power/getApplience.php", {
				params: {
					field: field,
					period: store.state.settime.periodTime,
					site: rootState.auth.defaultSiteName !== '' ? rootState.auth.defaultSiteName : rootState.auth.user.site
				},
			});

			return data;
		} catch (error) {
			console.log(error);
		}
	},
	async getPickedDateRangeData({ commit, state, dispatch, rootState }, payload) {
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
		try {
			const { data } = await axios.get(state.apiURL + "/power/getDateRangeCircuitData.php", {
				params: {
					field: payload.field,
					period: payload.picked,
					site: rootState.auth.defaultSiteName !== '' ? rootState.auth.defaultSiteName : rootState.auth.user.site
				},
			});
			return data;
		} catch (error) {
			const { data } = await axios.get(state.apiURL + "/user/refreshToken.php", {
				params: {
					user: rootState.auth.user.id
				}
			});
			localStorage.setItem('access_token', data.jwt);
			let _data = await dispatch('getPickedDateRangeData', payload);
			return _data;
		}

	},

	async getDisplayGenCircuitData({ commit, state, dispatch, rootState }) {
		let currentPower = [];
		let prevPower = [];
		let beforePrevPower = [];
		let predictPower = [];
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');

		try {
			const { data } = await axios.get(state.apiURL + "/power/getGenCircuit.php", {
				params: {
					period: store.state.settime.periodTime,
					site: rootState.auth.defaultSiteName !== '' ? rootState.auth.defaultSiteName : rootState.auth.user.site
				},
			});

			currentPower = data.current;
			prevPower = data.prev;
			beforePrevPower = data.beforePrev;
			commit("setGenPower", currentPower);

			switch (store.state.settime.periodTime) {
				case "today":
					let _hData = {
						current: currentPower,
						prev: prevPower,
						beforePrev: beforePrevPower
					};
					let _hPredictData = await dispatch("getGenHourPredictData", _hData);
					predictPower = _hPredictData;
					break;
				case "month":
					let _mData = {
						current: currentPower,
						prev: prevPower,
						beforePrev: beforePrevPower
					};

					let _mPredictData = await dispatch("getGenDayPredictData", _mData);
					predictPower = _mPredictData;
					break;
				case "year":
					let _yData = {
						current: currentPower,
						prev: prevPower,
						beforePrev: beforePrevPower
					};

					let _yPredictData = await dispatch("getGenMonthPredictData", _yData);
					predictPower = _yPredictData;
					break;
			}

			let returnData = [...currentPower, ...predictPower];
			returnData.sort((a, b) => new Date(a[0]) - new Date(b[0]));
			return returnData;
		} catch (error) {
			console.log(error);
		}
	},

	async getDisplayData({ commit, state, dispatch, rootState }, field) {
		let currentDayPower = [];
		let currentNightPower = [];
		let prevDayPower = [];
		let prevNightPower = [];
		let beforePrevDayPower = [];
		let beforePrevNightPower = [];
		let predictDayPower = [];
		let predictNightPower = [];
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');

		try {
			const { data } = await axios.get(state.apiURL + "/power/getCircuit.php", {
				params: {
					field: field,
					period: store.state.settime.periodTime,
					site: rootState.auth.defaultSiteName !== '' ? rootState.auth.defaultSiteName : rootState.auth.user.site
				},
			});

			currentDayPower = data.currentDay;
			currentNightPower = data.currentNight;
			prevDayPower = data.prevDay;
			prevNightPower = data.prevNight;
			beforePrevDayPower = data.beforePrevDay;
			beforePrevNightPower = data.beforePrevNight;
			if (
				store.state.settime.periodTime == "year" &&
				new Date().getFullYear() - 1 == 2021 &&
				prevDayPower.length > 0 &&
				prevNightPower.length > 0
			) {
				let data = [
					["2021-01-01", 0],
					["2021-02-01", 0],
					["2021-03-01", 0],
					["2021-04-01", 0],
					["2021-05-01", 0],
					["2021-06-01", 0],
					["2021-07-01", 0],
					["2021-08-01", 0],
				];
				prevDayPower = data.concat(prevDayPower);
				prevDayPower = prevDayPower.concat([["2021-12-01", prevDayPower[9][1]]]);
				prevNightPower = data.concat(prevNightPower);
				prevNightPower = prevNightPower.concat([["2021-12-01", prevNightPower[9][1]]]);
			}
			switch (store.state.settime.periodTime) {
				case "today":
					let _hData = {
						currentDay: currentDayPower,
						currentNight: currentNightPower,
						prevDay: prevDayPower,
						prevNight: prevNightPower,
						beforePrevDay: beforePrevDayPower,
						beforePrevNight: beforePrevNightPower,
					};
					let _hPredictData = await dispatch("getHourPredictData", _hData);
					predictDayPower = _hPredictData[0];
					predictNightPower = _hPredictData[1];
					break;
				case "month":
					let _mData = {
						currentDay: currentDayPower,
						currentNight: currentNightPower,
						prevDay: prevDayPower,
						prevNight: prevNightPower,
						beforePrevDay: beforePrevDayPower,
						beforePrevNight: beforePrevNightPower,
					};

					let _mPredictData = await dispatch("getDayPredictData", _mData);
					predictDayPower = _mPredictData[0];
					predictNightPower = _mPredictData[1];
					break;
				case "year":
					let _yData = {
						currentDay: currentDayPower,
						currentNight: currentNightPower,
						prevDay: prevDayPower,
						prevNight: prevNightPower,
					};

					let _yPredictData = await dispatch("getMonthPredictData", _yData);
					predictDayPower = _yPredictData[0];
					predictNightPower = _yPredictData[1];
					break;
			}
			if (field == "overall") {
				commit("setCurrentDayPower", currentDayPower);
				commit("setCurrentNightPower", currentNightPower);
				commit("setPrevDayPower", prevDayPower);
				commit("setPrevNightPower", prevNightPower);
				commit("setBeforePrevDayPower", beforePrevDayPower);
				commit("setBeforePrevNightPower", beforePrevNightPower);
				commit("setPredictDayPower", predictDayPower);
				commit("setPredictNightPower", predictNightPower);
			} else {
				return [
					currentDayPower,
					currentNightPower,
					prevDayPower,
					prevNightPower,
					beforePrevDayPower,
					beforePrevNightPower,
					predictDayPower,
					predictNightPower,
				];
			}
		} catch (error) {
			console.log(error);
		}

	},
	async getComparisonData({ commit, state, dispatch, rootState }, data) {
		let returnData = [];

		for (let i = 0; i < data['names'].length; i++) {
			let feedbackData = await dispatch('getSiteData', { site: data['names'][i], range: data['range'] });
			returnData.push(feedbackData);
		}

		return returnData;
	},
	async getSiteData({ commit, state, dispatch, rootState }, payload) {
		let currentDayPower = [];
		let currentNightPower = [];
		let prevDayPower = [];
		let prevNightPower = [];
		let beforePrevDayPower = [];
		let beforePrevNightPower = [];
		let predictDayPower = [];
		let predictNightPower = [];
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');

		try {
			const { data } = await axios.get(state.apiURL + "/power/getCircuit.php", {
				params: {
					field: 'overall',
					period: payload.range.length === 0 ? store.state.settime.periodTime : payload.range,
					site: payload.site
				},
			});

			// Get powers series for selected period
			currentDayPower = data.currentDay;
			currentNightPower = data.currentNight;
			prevDayPower = data.prevDay;
			prevNightPower = data.prevNight;
			beforePrevDayPower = data.beforePrevDay;
			beforePrevNightPower = data.beforePrevNight;

			switch (store.state.settime.periodTime) {
				case "today":
					let _hData = {
						currentDay: currentDayPower,
						currentNight: currentNightPower,
						prevDay: prevDayPower,
						prevNight: prevNightPower,
						beforePrevDay: beforePrevDayPower,
						beforePrevNight: beforePrevNightPower,
					};
					let _hPredictData = await dispatch("getHourPredictData", _hData);
					predictDayPower = _hPredictData[0];
					predictNightPower = _hPredictData[1];
					break;
				case "month":
					let _mData = {
						currentDay: currentDayPower,
						currentNight: currentNightPower,
						prevDay: prevDayPower,
						prevNight: prevNightPower,
						beforePrevDay: beforePrevDayPower,
						beforePrevNight: beforePrevNightPower,
					};

					let _mPredictData = await dispatch("getDayPredictData", _mData);
					predictDayPower = _mPredictData[0];
					predictNightPower = _mPredictData[1];
					break;
				case "year":
					let _yData = {
						currentDay: currentDayPower,
						currentNight: currentNightPower,
						prevDay: prevDayPower,
						prevNight: prevNightPower,
					};

					let _yPredictData = await dispatch("getMonthPredictData", _yData);
					predictDayPower = _yPredictData[0];
					predictNightPower = _yPredictData[1];
					break;
			}

			return [
				currentDayPower,
				currentNightPower,
				predictDayPower,
				predictNightPower,
			];
		} catch (error) {
			console.log(error);
		}
	},
	getMonthPredictData({ commit, state }, data) {
		let currentDayPower = data.currentDay;
		let currentNightPower = data.currentNight;
		let prevDayPower = data.prevDay;
		let prevNightPower = data.prevNight;

		let dayRate = 0;
		let nightRate = 0;
		let predictDay = [];
		let predictNight = [];

		if (prevDayPower.length > 0) {
			let count = 0;
			for (let i = 0; i < currentDayPower.length; i++) {
				if (prevDayPower[i][1] !== 0) {
					count++;
					dayRate += ((currentDayPower[i][1] - prevDayPower[i][1]) / prevDayPower[i][1]) * 100;
				}
			}

			if (count > 0) dayRate = dayRate / count;

			for (let i = currentDayPower.length; i < 12; i++) {
				if (!!prevDayPower[i]) {
					let year = new Date(prevDayPower[i][0]);
					year.setFullYear(year.getFullYear() + 1);
					let time = year.toISOString();
					let value = (prevDayPower[i][1] * (100 + dayRate)) / 100;
					predictDay.push([
						time,
						Math.round((value + Number.EPSILON) * 100) / 100,
					]);
				}
			}
		}

		if (prevNightPower.length > 0) {
			let count = 0;
			for (let i = 0; i < currentNightPower.length; i++) {
				if (prevNightPower[i][1] !== 0) {
					count++;
					nightRate += ((currentNightPower[i][1] - prevNightPower[i][1]) / prevNightPower[i][1]) * 100;
				}

			}

			if (count > 0) nightRate = nightRate / count;

			for (let i = currentNightPower.length; i < 12; i++) {
				if (!!prevNightPower[i]) {
					let year = new Date(prevNightPower[i][0]);
					year.setFullYear(year.getFullYear() + 1);
					let time = year.toISOString();
					let value = (prevNightPower[i][1] * (100 + nightRate)) / 100;
					predictNight.push([
						time,
						Math.round((value + Number.EPSILON) * 100) / 100,
					]);
				}
			}
		}

		if (prevDayPower.length === 0 && prevNightPower.length === 0) {
			for (let i = 2; i <= 12; i++) {
				let year = new Date().getFullYear();
				let yearString = '';

				if (i < 10) {
					yearString = year + '-0' + i + '-01';
				} else {
					yearString = year + '-' + i + '-01';
				}

				let item = currentDayPower.filter(i => i[0] === yearString);
				if (item.length === 0) {
					predictDay.push([yearString, 0]);
					predictNight.push([yearString, 0]);
				}
			}
		}

		return [predictDay, predictNight];
	},
	getDayPredictData({ commit, state }, data) {
		let currentDayPower = data.currentDay;
		let currentNightPower = data.currentNight;
		let prevDayPower = data.prevDay;
		let prevNightPower = data.prevNight;
		let beforePrevDayPower = data.beforePrevDay;
		let beforePrevNightPower = data.beforePrevNight;
		let dayRate = 0;
		let nightRate = 0;
		let predictDay = [];
		let predictNight = [];

		let today = new Date();
		let lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
		let lastDate = lastDay.getDate();

		let day = null;

		if (lastDate < 31) {
			let count = 0;
			for (let i = 0; i < currentDayPower.length; i++) {
				if (prevDayPower.length > 0 && !!prevDayPower[i] && prevDayPower[i][1] !== 0) {
					dayRate +=
						((currentDayPower[i][1] - prevDayPower[i][1]) /
							prevDayPower[i][1]) *
						100;
					count++;
				}
			}
			if (count > 0) dayRate = dayRate / count;

			for (let i = currentDayPower.length; i < lastDate; i++) {
				if (prevDayPower.length > 0 && !!prevDayPower[i] && prevDayPower[i][1] !== 0) {
					day = new Date(prevDayPower[i][0]);
					day.setMonth(day.getMonth() + 1);
					let time = day.toISOString();
					let value = (prevDayPower[i][1] * (100 + dayRate)) / 100;
					predictDay.push([
						time,
						Math.round((value + Number.EPSILON) * 100) / 100,
					]);
				}
			}

			count = 0;
			for (let i = 0; i < currentNightPower.length; i++) {
				if (prevNightPower.length > 0 && !!prevNightPower[i] && prevNightPower[i][1] !== 0) {
					nightRate +=
						((currentNightPower[i][1] - prevNightPower[i][1]) /
							prevNightPower[i][1]) *
						100;
					count++;
				}
			}
			if (count > 0) nightRate = nightRate / count;

			for (let i = currentNightPower.length; i < lastDate; i++) {
				if (prevNightPower.length > 0 && prevNightPower[i] && prevNightPower[i][1] !== 0) {
					day = new Date(prevNightPower[i][0]);
					day.setMonth(day.getMonth() + 1);
					let time = day.toISOString();
					let value = (prevNightPower[i][1] * (100 + nightRate)) / 100;
					predictNight.push([
						time,
						Math.round((value + Number.EPSILON) * 100) / 100,
					]);
				}
			}
		} else {
			let lastDay = new Date(today.getFullYear(), today.getMonth(), 0);
			let previousDate = lastDay.getDate();
			let count = 0;
			for (let i = 0; i < currentDayPower.length; i++) {
				if (prevDayPower.length > 0 && !!prevDayPower[i] && prevDayPower[i][1] > 1) {
					dayRate +=
						((currentDayPower[i][1] - prevDayPower[i][1]) /
							prevDayPower[i][1]) *
						100;
					count++;
				}
			}

			if (count > 0) dayRate = dayRate / count;

			if (prevDayPower.length > 0) {
				for (let i = currentDayPower.length; i < previousDate; i++) {
					if (!!prevDayPower[i]) {
						day = new Date(prevDayPower[i][0]);
						day.setMonth(day.getMonth() + 1);
						let time = day.toISOString();
						let value = (prevDayPower[i][1] * (100 + dayRate)) / 100;
						predictDay.push([
							time,
							Math.round((value + Number.EPSILON) * 100) / 100,
						]);
					}
				}
			}

			if (beforePrevDayPower.length > 0) {
				for (let i = previousDate; i < lastDate; i++) {
					if (!!beforePrevDayPower[i]) {
						day = new Date(beforePrevDayPower[i][0]);
						day.setMonth(day.getMonth() + 2);
						let time = day.toISOString();
						let value = (beforePrevDayPower[i][1] * (100 + dayRate)) / 100;
						predictDay.push([
							time,
							Math.round((value + Number.EPSILON) * 100) / 100,
						]);
					}
				}
			}

			count = 0;
			for (let i = 0; i < currentNightPower.length; i++) {
				if (prevNightPower.length > 0 && !!prevNightPower[i] && prevNightPower[i][1] !== 0) {
					nightRate +=
						((currentNightPower[i][1] - prevNightPower[i][1]) /
							prevNightPower[i][1]) *
						100;
					count++;
				}
			}

			if (count === 0) {
				nightRate = 0;
			} else {
				nightRate = nightRate / count;
			}

			if (prevNightPower.length > 0) {
				for (let i = currentNightPower.length; i < previousDate; i++) {
					if (!!prevNightPower[i]) {
						day = new Date(prevNightPower[i][0]);
						day.setMonth(day.getMonth() + 1);
						let time = day.toISOString();
						let value = (prevNightPower[i][1] * (100 + nightRate)) / 100;
						predictNight.push([
							time,
							Math.round((value + Number.EPSILON) * 100) / 100,
						]);
					}
				}
			}

			if (beforePrevNightPower.length > 0) {
				for (let i = previousDate; i < lastDate; i++) {
					if (!!beforePrevNightPower[i]) {
						day = new Date(beforePrevNightPower[i][0]);
						day.setMonth(day.getMonth() + 2);
						let time = day.toISOString();
						let value = (beforePrevNightPower[i][1] * (100 + nightRate)) / 100;
						predictNight.push([
							time,
							Math.round((value + Number.EPSILON) * 100) / 100,
						]);
					}
				}
			}
		}

		return [predictDay, predictNight];
	},
	getHourPredictData({ commit, state }, data) {
		let _currentDay = data.currentDay;
		let _currentNight = data.currentNight;
		let _prevDay = data.prevDay;
		let _prevNight = data.prevNight;
		let _beforePrevDay = data.beforePrevDay;
		let _beforePrevNight = data.beforePrevNight;
		let dayRate = 0,
			nightRate = 0;
		let predictDay = [],
			predictNight = [];

		let count = 0;

		if (_currentDay.length == 0) {
			for (let i = 0; i < _prevDay.length; i++) {
				if (!!_prevDay[i] && !!_beforePrevDay[i] && _beforePrevDay[i][1] !== 0) {
					dayRate += ((_prevDay[i][1] - _beforePrevDay[i][1]) / _beforePrevDay[i][1]) * 100;
					count++;
				}

			}

			if (count > 0) dayRate = dayRate / count;
		} else {
			for (let i = 0; i < _currentDay.length; i++) {
				if (_prevDay.length > 0 && !!_prevDay[i] && _prevDay[i][1] !== 0) {
					dayRate += ((_currentDay[i][1] - _prevDay[i][1]) / _prevDay[i][1]) * 100;
					count++;
				}

			}

			if (count > 0) dayRate = dayRate / count;
		}

		for (let i = _currentDay.length; i < _prevDay.length; i++) {
			let time = new Date(_prevDay[i][0]);
			time.setDate(time.getDate() + 1);
			let timeString = time.toISOString();
			let value = (_prevDay[i][1] * (100 + dayRate)) / 100;
			predictDay.push([
				timeString,
				Math.round((value + Number.EPSILON) * 100) / 100,
			]);
		}

		count = 0;
		for (let i = 0; i < _currentNight.length; i++) {
			if (!!_prevNight[i]) {
				nightRate +=
					((_currentNight[i][1] - _prevNight[i][1]) / _prevNight[i][1]) * 100;
				count++;
			}

		}
		if (count > 0) nightRate = nightRate / count;

		for (let i = _currentNight.length; i < _currentNight.length; i++) {
			if (!!_prevNight[i]) {
				let time = new Date(_prevNight[i][0]);
				time.setDate(time.getDate() + 1);
				let timeString = time.toISOString();
				let value = (_prevNight[i][1] * (100 + nightRate)) / 100;

				predictNight.push([
					timeString,
					Math.round((value + Number.EPSILON) * 100) / 100,
				]);
			}
		}

		return [predictDay, predictNight];
	},
	getGenHourPredictData({ commit, state }, data) {
		let _current = data.current;
		let _prev = data.prev;
		let _beforePrev = data.beforePrev;
		let rate = 0;
		let predict = [];

		let count = 0;

		if (_current.length == 0) {
			for (let i = 0; i < _prev.length; i++) {
				if (!!_prev[i] && !!_beforePrev[i] && _beforePrev[i][1] !== 0) {
					rate += ((_prev[i][1] - _beforePrev[i][1]) / _beforePrev[i][1]) * 100;
					count++;
				}

			}

			if (count > 0) rate = rate / count;
		} else {
			for (let i = 0; i < _current.length; i++) {
				if (_prev.length > 0 && !!_prev[i] && _prev[i][1] !== 0) {
					rate += ((_current[i][1] - _prev[i][1]) / _prev[i][1]) * 100;
					count++;
				}

			}

			if (count > 0) rate = rate / count;
		}

		for (let i = _current.length; i < _prev.length; i++) {
			let time = new Date(_prev[i][0]);
			time.setDate(time.getDate() + 1);
			let timeString = time.toISOString();
			let value = (_prev[i][1] * (100 + rate)) / 100;
			predict.push([
				timeString,
				Math.round((value + Number.EPSILON) * 100) / 100,
			]);
		}

		return predict;
	},
	getGenDayPredictData({ commit, state }, data) {
		let _current = data.current;
		let _prev = data.prev;
		let _beforePrev = data.beforePrev;
		let rate = 0;
		let predict = [];

		let today = new Date();
		let lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
		let lastDate = lastDay.getDate();

		let day = null;

		if (lastDate < 31) {
			let count = 0;
			for (let i = 0; i < _current.length; i++) {
				if (_prev.length > 0 && !!_prev[i] && _prev[i][1] !== 0) {
					rate +=
						((_current[i][1] - _prev[i][1]) / _prev[i][1]) *
						100;
					count++;
				}
			}
			if (count > 0) rate = rate / count;

			for (let i = _current.length; i < lastDate; i++) {
				if (_prev.length > 0 && !!_prev[i] && _prev[i][1] !== 0) {
					day = new Date(_prev[i][0]);
					day.setMonth(day.getMonth() + 1);
					let time = day.toISOString();
					let value = (_prev[i][1] * (100 + rate)) / 100;
					predict.push([
						time,
						Math.round((value + Number.EPSILON) * 100) / 100,
					]);
				}
			}
		} else {
			let lastDay = new Date(today.getFullYear(), today.getMonth(), 0);
			let previousDate = lastDay.getDate();
			let count = 0;
			for (let i = 0; i < _current.length; i++) {
				if (_prev.length > 0 && !!_prev[i] && _prev[i][1] > 1) {
					rate +=
						((_current[i][1] - _prev[i][1]) / _prev[i][1]) *
						100;
					count++;
				}
			}

			if (count > 0) rate = rate / count;

			if (_prev.length > 0) {
				for (let i = _current.length; i < previousDate; i++) {
					if (!!_prev[i]) {
						day = new Date(_prev[i][0]);
						day.setMonth(day.getMonth() + 1);
						let time = day.toISOString();
						let value = (_prev[i][1] * (100 + rate)) / 100;
						predict.push([
							time,
							Math.round((value + Number.EPSILON) * 100) / 100,
						]);
					}
				}
			}

			if (_beforePrev.length > 0) {
				for (let i = previousDate; i < lastDate; i++) {
					if (!!_beforePrev[i]) {
						day = new Date(_beforePrev[i][0]);
						day.setMonth(day.getMonth() + 2);
						let time = day.toISOString();
						let value = (_beforePrev[i][1] * (100 + rate)) / 100;
						predict.push([
							time,
							Math.round((value + Number.EPSILON) * 100) / 100,
						]);
					}
				}
			}
		}

		return predict;
	},
	getGenMonthPredictData({ commit, state }, data) {
		let _current = data.current;
		let _prev = data.prev;
		let _beforePrev = data.beforePrev;
		let rate = 0;
		let predict = [];

		let count = 0;

		if (_prev.length > 0) {
			let count = 0;
			for (let i = 0; i < _current.length; i++) {
				if (_prev[i][1] !== 0) {
					count++;
					rate += ((_current[i][1] - _prev[i][1]) / _prev[i][1]) * 100;
				}
			}

			if (count > 0) rate = rate / count;

			for (let i = _current.length; i < 12; i++) {
				if (!!_prev[i]) {
					let year = new Date(_prev[i][0]);
					year.setFullYear(year.getFullYear() + 1);
					let time = year.toISOString();
					let value = (_prev[i][1] * (100 + rate)) / 100;
					predict.push([
						time,
						Math.round((value + Number.EPSILON) * 100) / 100,
					]);
				}
			}
		}


		if (_prev.length === 0) {
			for (let i = 2; i <= 12; i++) {
				let year = new Date().getFullYear();
				let yearString = '';

				if (i < 10) {
					yearString = year + '-0' + i + '-01';
				} else {
					yearString = year + '-' + i + '-01';
				}

				let item = _current.filter(i => i[0] === yearString);
				if (item.length === 0) {
					predict.push([yearString, 0]);
				}
			}
		}

		return predict;
	},
	processData({ commit, state }, data) {
		let lineChartFields = [];

		if (data.length > 0) {
			let compareTable = data[0].table;
			let compareResults = data.filter((e) => e.table == compareTable);

			compareResults.forEach((item) => {
				let sameTimeResults = data.filter((p) => p._time == item._time);
				let total = 0;

				sameTimeResults.forEach((same, index) => {
					total += same._value / 1000;
				});

				lineChartFields.push([item._time, parseFloat(total.toFixed(2))]);
			});
		}
		return lineChartFields;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
